import {
    asyncScheduler,
    debounceTime,
    MonoTypeOperatorFunction,
    Observable,
    skip,
    throttleTime,
} from 'rxjs'

export const defaultDebounceTime = <T>(): MonoTypeOperatorFunction<T> => {
    return (source: Observable<T>): Observable<T> => source.pipe(debounceTime(300))
}

export const defaultDebounceTimeSkipFirst = <T>(): MonoTypeOperatorFunction<T> => {
    return (source: Observable<T>): Observable<T> => source.pipe(skip(1), defaultDebounceTime())
}

export const defaultStoreConnectorThrottle = <T>(): MonoTypeOperatorFunction<T> => {
    return (source: Observable<T>): Observable<T> =>
        source.pipe(skip(1), throttleTime(250, asyncScheduler, { leading: true, trailing: true }))
}
